<script setup lang="ts">
import { ref } from 'vue';
import InputSwitch from 'primevue/inputswitch';
import { EMIT } from '@/enum';

const emit = defineEmits<{
  (e: EMIT.ENABLE): void;
  (e: EMIT.DISABLE): void;
}>();
const showArchived = ref(false);
const handleToggle = () => (showArchived.value ? emit(EMIT.ENABLE) : emit(EMIT.DISABLE));
</script>

<template>
  <div class="inline-flex align-items-center">
    <InputSwitch v-model="showArchived" @change="handleToggle" />
    <p class="archive_label label pl-2 align-items-center flex font-semibold">Show Archived</p>
  </div>
</template>

<style lang="scss" scoped>
.p-inputswitch-slider {
  background: $grayLight;
}
.archive_label {
  color: $grayDark;
}
</style>
